import { FC, MouseEventHandler } from "react";
import { useFormContext } from "react-hook-form";

import { classNames } from "@utils/class-names";

interface Props {
  text: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const SubmitButton: FC<Props> = ({ text, className, onClick, disabled }) => {
  const {
    formState: { isValid },
  } = useFormContext();

  return (
    <div className="flex justify-center items-center">
      <button
        type="submit"
        className={classNames(
          "bg-black text-white rounded border border-black h-10 px-4 transition duration-200",
          disabled ?? !isValid
            ? "bg-gray-400"
            : "hover:bg-white hover:text-black",
          className || ""
        )}
        {...{ disabled: disabled ?? (isValid ? undefined : true) }}
        onClick={onClick}
      >
        {text}
      </button>
    </div>
  );
};

export default SubmitButton;
